<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: luoxi
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-08 11:45:34
 -->
<template>
  <ul class="part6">
    <div class="title">组织信息 Organization information</div>
    <li>
      <el-input
        placeholder="请输入内容"
        v-model="part6.organizeChorusCh"
        :disabled="stateCode==6||stateCode==0?false:true"
      >
        <template slot="prepend">合唱团名称：</template>
      </el-input>
    </li>
    <li>
      <el-input
        placeholder="请输入内容"
        v-model="part6.organizeChorusEn"
        :disabled="stateCode==6||stateCode==0?false:true"
      >
        <template slot="prepend">Name of the group：</template>
      </el-input>
    </li>
    <li>
      <div class="left">
        <el-input
          placeholder="请输入内容"
          v-model="part6.organizeCountCh"
          :disabled="stateCode==6||stateCode==0?false:true"
        >
          <template slot="prepend">歌者人数：</template>
        </el-input>
        <el-input
          placeholder="请输入内容"
          v-model="part6.organizeTogetherCountCh"
          :disabled="stateCode==6||stateCode==0?false:true"
        >
          <template slot="prepend">随同人员人数（包括指挥、乐队/伴奏、随同人员）：</template>
        </el-input>
        <el-input
          placeholder="请输入内容"
          v-model="part6.organizeCarCountCh"
          :disabled="stateCode==6||stateCode==0?false:true"
        >
          <template slot="prepend">巴士司机人数：</template>
        </el-input>
      </div>
      <div class="right">
        <el-input
          placeholder="请输入内容"
          v-model="part6.organizeTotalCountCh"
          :disabled="stateCode==6||stateCode==0?false:true"
        >
          <template slot="prepend">总人数：</template>
        </el-input>
      </div>
    </li>
    <li>
      <div class="left">
        <el-input
          placeholder="请输入内容"
          v-model="part6.organizeCountEn"
          :disabled="stateCode==6||stateCode==0?false:true"
        >
          <template slot="prepend">Number of singers：</template>
        </el-input>
        <el-input
          placeholder="请输入内容"
          v-model="part6.organizeTogetherCountEn"
          :disabled="stateCode==6||stateCode==0?false:true"
        >
          <template slot="prepend">
            Number of accompanying persons (conductor, band/accompanists,
            chaperones)：
          </template>
        </el-input>
        <el-input
          placeholder="请输入内容"
          v-model="part6.organizeCarCountEn"
          :disabled="stateCode==6||stateCode==0?false:true"
        >
          <template slot="prepend">Number of bus drivers：</template>
        </el-input>
      </div>
      <div class="right">
        <el-input
          placeholder="请输入内容"
          v-model="part6.organizeTotalCountEn"
          :disabled="stateCode==6||stateCode==0?false:true"
        >
          <template slot="prepend">Total number of participants：</template>
        </el-input>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    Organizainforh: {
      type: Object,
      default() {
        return {
          type: 0,
          data: null,
        };
      },
    },
    stateCode: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  components: {},
  computed: {},
  data() {
    return {
      part6: {
        organizeChorusCh: "", //合唱团名称
        organizeChorusEn: "",
        organizeCountCh: "", //歌者人数
        organizeCountEn: "",
        organizeTogetherCountCh: "", //随同人员人数（包括指挥、乐队/伴奏、随同人员）
        organizeTogetherCountEn: "",
        organizeTotalCountCh: "", //总人数
        organizeTotalCountEn: "",
        organizeCarCountCh: "", //巴士司机人数
        organizeCarCountEn: "",
      },
    };
  },

  created() {},
  mounted() {
    this.getdetails();
  },
  methods: {
    getdetails() {
      this.part6.organizeChorusCh = this.Organizainforh.organizeChorusCh;
      this.part6.organizeChorusEn = this.Organizainforh.organizeChorusEn;
      this.part6.organizeCountCh = this.Organizainforh.organizeCountCh;
      this.part6.organizeCountEn = this.Organizainforh.organizeCountEn;
      this.part6.organizeTogetherCountCh =
        this.Organizainforh.organizeTogetherCountCh;
      this.part6.organizeTogetherCountEn =
        this.Organizainforh.organizeTogetherCountEn;
      this.part6.organizeTotalCountCh =
        this.Organizainforh.organizeTotalCountCh;
      this.part6.organizeTotalCountEn =
        this.Organizainforh.organizeTotalCountEn;
      this.part6.organizeCarCountCh = this.Organizainforh.organizeCarCountCh;
      this.part6.organizeCarCountEn = this.Organizainforh.organizeCarCountEn;
    },

    alltotal() {
      this.part6.organizeTotalCountCh = "";
      this.part6.organizeTotalCountCh =
        parseInt(this.part6.organizeCountCh) +
        parseInt(this.part6.organizeTogetherCountCh) +
        parseInt(this.part6.organizeCarCountCh);
    },
    alltotalen() {
      this.part6.organizeTotalCountEn = "";
      this.part6.organizeTotalCountEn =
        parseInt(this.part6.organizeCountEn) +
        parseInt(this.part6.organizeTogetherCountEn) +
        parseInt(this.part6.organizeCarCountEn);
    },
  },
};
</script>

<style scoped="" lang="scss">
.part6 {
  .title {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #3c4353;
    margin: 48px 48px;
  }

  li {
    display: flex;
    padding-left: 100px;
    padding-right: 100px;
    margin-top: 20px;

    .el-input {
      /deep/ .el-input-group__prepend {
        border-right: 0;
        color: rgba(36, 85, 139, 1);
        background: white;
        padding-right: 0px;
      }
      /deep/.el-input__inner {
        border-left: 0;
        padding: 0 15px 0 0;
        &:focus {
          border-color: #dcdfe6;
          outline: 0;
        }
      }
    }

    .radiobox {
      width: 30%;
      border: 1px solid gainsboro;
      .el-radio {
        margin-left: 30px;
        margin-top: 14px;
      }
    }
    p {
      color: rgba(36, 85, 139, 1);
      line-height: 32px;
    }
  }
  .right {
    flex: 1;
    border: 1px solid #dcdfe6;
    .el-input-group {
      margin-top: 41px;
      /deep/.el-input__inner {
        border: none;
      }
      /deep/.el-input-group__prepend {
        border: none;
      }
    }
  }
  .left {
    width: 67%;
    .el-input {
      /deep/.el-input__inner {
        border-right: none;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      &:first-of-type {
        /deep/.el-input__inner {
          border-bottom: none;
        }
        /deep/.el-input-group__prepend {
          border-bottom: none;
        }
      }
      &:last-of-type {
        /deep/.el-input__inner {
          border-top: none;
        }
        /deep/.el-input-group__prepend {
          border-top: none;
        }
      }
    }
  }
  li:nth-of-type(3) {
    margin-top: 30px;
  }

  li:nth-of-type(5) {
    margin-top: 30px;
  }
}
</style>
